import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import styled from 'styled-components'
///import moment from 'moment'
//import { useAlert } from 'react-alert'
import { useDispatch } from 'react-redux'

import { GetApi } from '../../../Common/ApiAxios'
import { SetLoadSpinner } from '../../../Common/Slice/LoadSpinnerSlice'
//import Calendar from '../../../Common/Atoms/Calendar'
import Input from '../../../Common/Atoms/Input'
import NormalButton from '../../../Common/Atoms/NormalButton'
//import Select from '../../../Common/Atoms/SelectAddValue'
//import * as HealthCareUtilty from '../../../Common/Utilties/HealthCareUtilty'

import CloseIcon from '../../../../image/close_icon.png'


//import MediaAccidentHeader from './MediaAccidentHeader'
//import MediaAccident from './MediaAccident'
//import * as MapWrap from '../../Wrap/PositioningMapWrap'
//import { DefaultUrl } from '../../PositioningBoard'
//import { conforms } from 'lodash'

/* 横並 */
const Flex = styled.div`
  display: flex; /* 横並び */
  flex-flow: row nowrap;
`

/* 縦並 */
const Wrap = styled.div`
  display:flex;
  flex-flow: column;
`

const ColumnFlex = styled.div`
  display: flex; /* 横並び */
  flex-flow: row nowrap;
  text-align: left;
  align-items: center;
  marign: 2rem;
  height: 40px;
`

const ColumnName = styled.div`
  width: 4rem;
  margin-left: 1rem;
  text-align: left;
  align-items: center;
`

const AIModal = (props) => {
  const {
    //grants,
    type,
    modalIsOpen,
    setIsOpen,
  } = props
  const dispatch = useDispatch();
  //const alert = useAlert();
  const [responseGemini, setResponseGemini] = useState('');
  const promptRef = useRef();

  // モーダル
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      //opacity: 0.8,
      padding: '10px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    },
    overlay: {
      //background: 'rgba(0, 0, 0, 0.7)',
      zIndex: 10
    }
  }

  //ダイアログ開いた時の処理
  function afterOpenModal () {
    promptRef.current.value = '';
  }

  function closeModal () {
      setIsOpen(false);
  }

  // Gemini API質問ボタンクリックイベント
  async function  onClickRequestGemini() {
    console.log('call requestGemini');
    const prompt = promptRef.current.value;
    console.log(prompt);
    if (!prompt || prompt === '') {
      console.log('erro param');
      alert('質問文を入力してください。');
      return;
    }

    apiRequestGemini(prompt, true);
  }

  // Gemini AI 検索
  const apiRequestGemini = async (prompt, isLoadSplinner) => {
    console.log('cal apiDeleteNotice');
    if (isLoadSplinner)
      dispatch(SetLoadSpinner(true));

    const apiUrl = `https://generative-ai-api.pal-style.co.jp/api/coreboard/manual?text=${prompt}`;
    await fetch(apiUrl, {
      method: 'GET', 
      mode: 'cors',
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok.");
      }
      return response.json();
    })
  .then((json) => {
    console.log(json);
    setResponseGemini(json.answer);
    console.log(json.answer);
  })
  // jsonの型がany型になる
  .catch((error) => console.log(error));

    if (isLoadSplinner)
      dispatch(SetLoadSpinner(false));
  }

  //if (!grants) return null;
  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel='Request AI Modal'
      ariaHideApp={false}
    >
      <div style={{ width: '50rem', height: '500px'}}>
        <Wrap>
          <Flex>
            <div style={{ height:'20px', marginLeft:'10px', marginTop:'10px', cursor: 'pointer'}}>
              Gemini AI テスト
            </div>
            <div style={{ height:'20px', marginLeft:'auto', marginRight:'10px', marginTop:'10px', cursor: 'pointer'}}>
              <img alt='閉じる' className='close' src={CloseIcon} title={'ダイアログを閉じる'} width="12px" onClick={closeModal} />
            </div>
          </Flex>
          <Wrap style={{marginTop:'1rem'}}>
            <ColumnFlex>
              <ColumnName>質問</ColumnName>
              <div style={{marginLeft:'10px'}}>
                <Input
                  type='text' 
                  width='40rem'
                  placeholder='例：アイテム詳細の見方をおしえてください。'
                  name='content'
                  maxLength='50'
                  inputRef={promptRef} 
                  //errors={errors}
                  //disabled={isDeleted || !canWrite}
                />
              </div>
            </ColumnFlex>
            <ColumnFlex style={{height:'320px'}}>
              <ColumnName>回答</ColumnName>
              <div style={{marginLeft:'10px', minWidth:'40rem', maxWidth:'40rem', minHeight:'300px',maxHeight:'300px', border:'1px solid #000', overflow:'auto'}}>
                <pre>{responseGemini}</pre>
              </div>
            </ColumnFlex>
          </Wrap>
          <div style={{marginLeft:'auto', marginRight:'10px', marginTop:'30px', cursor: 'pointer'}}>
            <NormalButton name='質問' onClick={onClickRequestGemini} />
          </div>
        </Wrap>
      </div>
    </Modal>
  )
}

AIModal.propTypes = {
  grants: PropTypes.object, // 権限関連
  modalIsOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
}

export default AIModal
